import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Select } from 'antd';

import { RootState } from '../../reducers/store';
import { ClientContextType } from '../../contexts/Client/types';

interface DistrictsTagsProps {
  town: string;
  onSelectChange: (tags: Array<string>) => void;
  client: ClientContextType;
  defaultValue: string[];
  disabled: boolean;
}

const { Option } = Select;

const DistrictsTags: React.FC<DistrictsTagsProps> = ({
  town,
  onSelectChange,
  client,
  defaultValue,
  disabled,
}) => {
  const [options, setOptions] = useState<Array<string>>([]);

  const { get } = client;

  useEffect(() => {
    get<any>(`/places/districts${town ? `?town=${town}` : ''}`, ({ data }) => {
      data && setOptions(data);
    });
  }, [get, town]);

  return (
    <>
      <Select
        id="districtsTags"
        mode="multiple"
        placeholder="Insérer le(s) quartier(s) ici"
        defaultValue={defaultValue}
        style={{ width: '100%' }}
        onChange={onSelectChange}
        disabled={disabled}
      >
        {options.map(
          (option: string, key: number) =>
            option && (
              <Option id={`district${key}`} key={option} value={option}>
                {option}
              </Option>
            )
        )}
      </Select>
    </>
  );
};

const mapStateToProps = ({ client }: RootState) => ({ client });

export default connect(mapStateToProps)(DistrictsTags);
